module.exports = __webpack_public_path__ + "static/media/Stellar Single Bed Base - 120x200 cm_Black.7d3b62c0.png";